
export const carBrands = [
  'Seat', 'Volkswagen', 'Renault', 'Peugeot', 'Citroën', 'Ford', 'Opel',
  'Toyota', 'BMW', 'Mercedes-Benz', 'Audi', 'Hyundai', 'Kia', 'Fiat',
  'Nissan', 'Honda', 'Mazda', 'Skoda', 'Dacia', 'Volvo', 'Jeep',
  'Suzuki', 'Mitsubishi', 'Chevrolet', 'Alfa Romeo', 'Mini', 'Smart',
  'Land Rover', 'Jaguar', 'Porsche', 'Lexus', 'Subaru', 'Otro'
];

export const carModels: Record<string, string[]> = {
  'Seat': ['Ibiza', 'León', 'Arona', 'Ateca', 'Tarraco', 'Alhambra', 'Toledo', 'Córdoba', 'Mii', 'Altea', 'Otro'],
  'Volkswagen': ['Golf', 'Polo', 'Passat', 'Tiguan', 'T-Roc', 'Touran', 'Touareg', 'Up!', 'Arteon', 'T-Cross', 'Caddy', 'Otro'],
  'Renault': ['Clio', 'Mégane', 'Captur', 'Kadjar', 'Scénic', 'Twingo', 'Laguna', 'Koleos', 'Talisman', 'Kangoo', 'Otro'],
  'Peugeot': ['208', '308', '2008', '3008', '5008', '508', '207', '307', '407', '206', 'Partner', 'Otro'],
  'Citroën': ['C3', 'C4', 'C5', 'Berlingo', 'C1', 'C-Elysée', 'Xsara', 'Saxo', 'C4 Picasso', 'C3 Aircross', 'Otro'],
  'Ford': ['Focus', 'Fiesta', 'Kuga', 'Mondeo', 'Puma', 'EcoSport', 'Galaxy', 'S-Max', 'Ka', 'C-Max', 'Otro'],
  'Opel': ['Corsa', 'Astra', 'Mokka', 'Crossland', 'Grandland', 'Insignia', 'Zafira', 'Meriva', 'Vectra', 'Otro'],
  'Toyota': ['Yaris', 'Corolla', 'RAV4', 'C-HR', 'Auris', 'Avensis', 'Aygo', 'Land Cruiser', 'Prius', 'Hilux', 'Otro'],
  'BMW': ['Serie 1', 'Serie 2', 'Serie 3', 'Serie 4', 'Serie 5', 'X1', 'X3', 'X5', 'X6', 'Z4', 'Otro'],
  'Mercedes-Benz': ['Clase A', 'Clase B', 'Clase C', 'Clase E', 'Clase S', 'GLA', 'GLC', 'GLE', 'CLA', 'Vito', 'Otro'],
  'Audi': ['A1', 'A3', 'A4', 'A5', 'A6', 'Q2', 'Q3', 'Q5', 'Q7', 'TT', 'Otro'],
  'Hyundai': ['i20', 'i30', 'Tucson', 'Kona', 'i10', 'Santa Fe', 'ix35', 'ix20', 'Ioniq', 'Otro'],
  'Kia': ['Ceed', 'Sportage', 'Rio', 'Stonic', 'Niro', 'Picanto', 'Sorento', 'Venga', 'Optima', 'Otro'],
  'Fiat': ['500', 'Punto', 'Panda', 'Tipo', '500X', '500L', 'Bravo', 'Stilo', 'Doblò', 'Otro'],
  'Nissan': ['Qashqai', 'Juke', 'Micra', 'X-Trail', 'Note', 'Pulsar', 'Navara', 'Leaf', 'Pathfinder', 'Otro'],
  'Honda': ['Civic', 'Jazz', 'CR-V', 'HR-V', 'Accord', 'FR-V', 'Otro'],
  'Mazda': ['Mazda2', 'Mazda3', 'Mazda6', 'CX-3', 'CX-5', 'CX-30', 'MX-5', 'Otro'],
  'Skoda': ['Octavia', 'Fabia', 'Superb', 'Karoq', 'Kodiaq', 'Kamiq', 'Rapid', 'Yeti', 'Otro'],
  'Dacia': ['Sandero', 'Duster', 'Logan', 'Lodgy', 'Dokker', 'Spring', 'Otro'],
  'Volvo': ['V40', 'V60', 'V90', 'XC40', 'XC60', 'XC90', 'S60', 'S90', 'Otro'],
  'Jeep': ['Renegade', 'Compass', 'Cherokee', 'Grand Cherokee', 'Wrangler', 'Otro'],
  'Suzuki': ['Vitara', 'Swift', 'Jimny', 'S-Cross', 'Ignis', 'Baleno', 'Otro'],
  'Mitsubishi': ['ASX', 'Outlander', 'Eclipse Cross', 'L200', 'Space Star', 'Otro'],
  'Chevrolet': ['Spark', 'Aveo', 'Cruze', 'Captiva', 'Orlando', 'Trax', 'Otro'],
  'Alfa Romeo': ['Giulietta', 'Giulia', 'Stelvio', 'MiTo', '159', '147', 'Otro'],
  'Mini': ['Cooper', 'Countryman', 'Clubman', 'Cabrio', 'Paceman', 'Otro'],
  'Smart': ['ForTwo', 'ForFour', 'Roadster', 'Otro'],
  'Land Rover': ['Range Rover', 'Range Rover Sport', 'Discovery', 'Defender', 'Freelander', 'Evoque', 'Otro'],
  'Jaguar': ['XE', 'XF', 'F-Pace', 'E-Pace', 'F-Type', 'XJ', 'Otro'],
  'Porsche': ['Cayenne', 'Macan', 'Panamera', '911', 'Boxster', 'Cayman', 'Otro'],
  'Lexus': ['IS', 'NX', 'RX', 'UX', 'CT', 'ES', 'Otro'],
  'Subaru': ['Forester', 'Outback', 'XV', 'Impreza', 'Legacy', 'Otro'],
  'Otro': ['Otro modelo']
};

export const vehicleConditions = [
  { value: 'funciona', label: 'Funciona correctamente', icon: 'ri-checkbox-circle-line', factor: 1.0 },
  { value: 'averiado-arranca', label: 'Averiado pero arranca', icon: 'ri-tools-line', factor: 0.7 },
  { value: 'no-arranca', label: 'No arranca', icon: 'ri-forbid-line', factor: 0.45 },
  { value: 'accidentado', label: 'Accidentado', icon: 'ri-car-crash-line', factor: 0.35 },
  { value: 'sin-itv', label: 'Sin ITV vigente', icon: 'ri-file-warning-line', factor: 0.55 },
  { value: 'desguace', label: 'Para desguace total', icon: 'ri-recycle-line', factor: 0.2 }
];

export const brandTiers: Record<string, number> = {
  'Porsche': 3,
  'Land Rover': 3,
  'Jaguar': 3,
  'BMW': 2,
  'Mercedes-Benz': 2,
  'Audi': 2,
  'Volvo': 2,
  'Lexus': 2,
  'Mini': 2,
  'Alfa Romeo': 2,
  'Subaru': 2
};

export const fuelTypes = [
  { value: 'gasolina', label: 'Gasolina' },
  { value: 'diesel', label: 'Diésel' },
  { value: 'hibrido', label: 'Híbrido' },
  { value: 'electrico', label: 'Eléctrico' },
  { value: 'glp', label: 'GLP / Gas' }
];
